import { render, staticRenderFns } from "./NotificationError.vue?vue&type=template&id=5441cf1a&scoped=true&"
import script from "./NotificationError.vue?vue&type=script&lang=js&"
export * from "./NotificationError.vue?vue&type=script&lang=js&"
import style0 from "./NotificationError.vue?vue&type=style&index=0&id=5441cf1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5441cf1a",
  null
  
)

export default component.exports